import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzPupWt } from './pages'

type TIdToPageMapWoofzPupWt = Record<PageIdWoofzPupWt, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_PUP_WT: TIdToPageMapWoofzPupWt = {
  [PageIdWoofzPupWt.DOG_AGE_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/DogAge').then((m) => ({
        default: m.DogAge,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_wt/pages/questions/DogAge'),
  },
  [PageIdWoofzPupWt.DOG_OWNER_PUP_WT]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/questions/DogOwnerQuestion'
      ).then((m) => ({
        default: m.DogOwnerQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/DogOwnerQuestion'),
  },
  [PageIdWoofzPupWt.TRAINING_COMMANDS_PUP_WT]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/questions/BasicTrainingCommands'
      ).then((m) => ({
        default: m.BasicTrainingCommands,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/questions/BasicTrainingCommands'
      ),
  },
  [PageIdWoofzPupWt.URGE_PAGE_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_wt/pages/urge/UrgePage'),
  },
  [PageIdWoofzPupWt.DOG_BREED_PUP_WT]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/questions/DogBreedQuestion'
      ).then((m) => ({
        default: m.DogBreedQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/DogBreedQuestion'),
  },
  [PageIdWoofzPupWt.FACING_CHALLENGES_PUP_WT]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/questions/FacingChallenges'
      ).then((m) => ({
        default: m.FacingChallenges,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/FacingChallenges'),
  },
  [PageIdWoofzPupWt.FACING_CHALLENGES_2_PUP_WT]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/questions/FacingChallengesVersion2'
      ).then((m) => ({
        default: m.FacingChallengesVersion2,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/questions/FacingChallengesVersion2'
      ),
  },
  [PageIdWoofzPupWt.BEHAVIOR_FREQUENCY_PUP_WT]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/questions/BehaviorFrequency'
      ).then((m) => ({
        default: m.BehaviorFrequency,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/BehaviorFrequency'),
  },
  [PageIdWoofzPupWt.URGE_PROGRAM_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/urge/UrgeProgram').then((m) => ({
        default: m.UrgeProgram,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_wt/pages/urge/UrgeProgram'),
  },
  [PageIdWoofzPupWt.BEHAVIOR_FEELINGS_PUP_WT]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/questions/BehaviorFeelings'
      ).then((m) => ({
        default: m.BehaviorFeelings,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/BehaviorFeelings'),
  },
  [PageIdWoofzPupWt.FIX_BEHAVIOR_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/FixDogBehavior').then(
        (m) => ({
          default: m.FixDogBehavior,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/FixDogBehavior'),
  },
  [PageIdWoofzPupWt.URGE_PAGE_4_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/urge/UrgePageVariant4'),
  },
  [PageIdWoofzPupWt.COMMANDS_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/DogCommands').then(
        (m) => ({
          default: m.DogCommands,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/DogCommands'),
  },
  [PageIdWoofzPupWt.PARENT_GOAL_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/GoalQuestion').then(
        (m) => ({
          default: m.GoalQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/GoalQuestion'),
  },
  [PageIdWoofzPupWt.TRAINING_PLACE_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/TrainingPlace').then(
        (m) => ({
          default: m.TrainingPlace,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/TrainingPlace'),
  },
  [PageIdWoofzPupWt.TRAINING_FREQUENCY_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/TimeQuestion').then(
        (m) => ({
          default: m.TimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/questions/TimeQuestion'),
  },
  [PageIdWoofzPupWt.URGE_PAGE_5_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/urge/UrgePageVariant5'),
  },
  [PageIdWoofzPupWt.PREPARE_FLOW_PUP_WT]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/prepare-flow/PrepareFlowPpp'
      ).then((m) => ({
        default: m.PrepareFlowPpp,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/prepare-flow/PrepareFlowPpp'),
  },
  [PageIdWoofzPupWt.EMAIL_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/email/EmailPpp').then((m) => ({
        default: m.EmailPpp,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_wt/pages/email/EmailPpp'),
  },
  [PageIdWoofzPupWt.NEWSLETTER_URGE_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.NewsletterUrge,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzPupWt.LAST_CHANCE_OFFER_PUP_WT]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/last-chance-offer/LastChanceOfferPpp'
      ).then((m) => ({
        default: m.LastChanceOfferPpp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/last-chance-offer/LastChanceOfferPpp'
      ),
  },
  [PageIdWoofzPupWt.SUBSCRIPTIONS_PUP_WT]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/subscriptions/Subscriptions'
      ).then((m) => ({
        default: m.Subscriptions,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/subscriptions/Subscriptions'),
  },
  [PageIdWoofzPupWt.CHAT_UPSELL_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzPupWt.UPSELL_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_pup_wt/pages/upsell/Upsell'),
  },
  [PageIdWoofzPupWt.UPSELL_FEEDING_GUIDE_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/upsell/FeedingGuideUpsell'),
  },
  [PageIdWoofzPupWt.UPSELL_EMOTIONAL_SUPPORT_PUP_WT]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_pup_wt/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageIdWoofzPupWt.DOWNLOAD_PUP_WT]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_pup_wt/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_pup_wt/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzPupWt.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
